/* eslint-disable dot-notation */
import axios from 'axios';
const apiFilesClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_FILES_URL}api/v1/files/`,
  headers: {
    ENV: process.env.VUE_APP_ENV,
    APIKey: process.env.VUE_APP_API_KEY,
    Authorization: null
  }
});
export default {
  post (url, payload, accessToken) {
    if (!accessToken) {
      accessToken = payload;
      payload = {};
    }
    apiFilesClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiFilesClient.post(url, payload);
  },
  put (url, payload, accessToken) {
    apiFilesClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiFilesClient.put(url, payload);
  },
  get (url, accessToken) {
    apiFilesClient.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
    return apiFilesClient.get(url);
  }
};
